export { default } from '@shikijs/langs/swift'
